import { render, staticRenderFns } from "./DdTeikeiCourseKensakuTextBox.vue?vue&type=template&id=33a8b820&scoped=true&"
import script from "./DdTeikeiCourseKensakuTextBox.vue?vue&type=script&lang=js&"
export * from "./DdTeikeiCourseKensakuTextBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8b820",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
